export default __webpack_public_path__ + "static/media/minus_icon_B.14cc3bd1.svg";